import React from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";
import "./style.scss";

// 10.10: подтверждение после оплаты (PayPlus и Продамус). Раньше было видно только
// мелькнувшее сообщение платёжки внутри рамки, и не было ясно, прошла ли оплата.
// Открывается из PaymentPage/controller после того, как бэк подтвердил покупку;
// закрывается крестиком. preventClose не ставим: с ним BaseModal не рисует крестик.
export default function PaymentSuccessModal() {
  const { t } = useTranslation();

  return (
    <BaseModal
      className="payment-success-modal"
      title={t("payment_success.title")}
      titleStyle="payment-success-modal__title"
      description={t("payment_success.desc")}
      descriptionStyle="payment-success-modal__description"
      eventTypeModal={MODAL_TYPES.PAYMENT_SUCCESS}
    ></BaseModal>
  );
}
